import React, { forwardRef, useImperativeHandle, useState } from "react"

export type ActionSheetRef = {
  setModalVisible: (visible: boolean) => void
}

const ActionSheet = forwardRef<
  ActionSheetRef,
  {
    children?: React.ReactNode
    closeOnTouchBackdrop?: boolean
    onClose?: () => void
  }
>(function ActionSheet({ children, closeOnTouchBackdrop = true, onClose }, ref) {
  const [visible, setVisible] = useState(false)

  const close = () => {
    setVisible(false)
    onClose?.()
  }

  useImperativeHandle(ref, () => ({
    setModalVisible: (nextVisible: boolean) => {
      if (nextVisible) {
        setVisible(true)
        return
      }
      close()
    },
  }))

  if (!visible) return null

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
      }}
    >
      {closeOnTouchBackdrop ? (
        <div
          role="presentation"
          style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.45)" }}
          onClick={close}
        />
      ) : null}
      <div
        style={{
          position: "relative",
          background: "#fff",
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          maxHeight: "70vh",
          overflow: "auto",
        }}
      >
        {children}
      </div>
    </div>
  )
})

export default ActionSheet

export function registerSheet() {}
